import React from 'react';
import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Button, FormGroup, Input, Modal, Text } from '@components/common';
import { LocationInput } from '@components/common/LocationInput';

import { ConsentFormParams } from './types';

interface Props {
  fields: ConsentFormField[];
  onCancel: () => void;
  onSubmit: (params: ConsentFormParams) => Promise<void>;
}

export const ConsentDetailsModal: React.FC<React.PropsWithChildren<Props>> = ({ fields, onSubmit, onCancel }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<ConsentFormParams>({});

  const { t } = useTranslation('ConsentFormPage');

  function change(key, value) {
    setData({ ...data, [key]: value });
  }
  async function handleSubmit() {
    if (loading) return;

    setLoading(true);
    await onSubmit(data);
    setLoading(false);
  }

  return (
    <Modal
      title={t('details')}
      size='md'
      disableAutofocus
      onClose={onCancel}
      renderFooter={() => (
        <>
          <Button onClick={onCancel}>{t('cancel')}</Button>
          <Button noStyle className='btn-custom-brand' onClick={handleSubmit}>
            {t('submit')}
          </Button>
        </>
      )}
    >
      <div className='text-left'>
        <Text mb='4'>{t('following_details')}</Text>
        {fields.map((f, i) => (
          <FormGroup key={f}>
            <Text bold mb='1' as='label' htmlFor={f}>
              {t(`fields.${f}.label`)}
            </Text>
            {f === 'signature' && (
              <Text h='400' mb='1' as='p' id='description'>
                {t(`fields.${f}.description`)}
              </Text>
            )}
            {f === 'address' ? (
              <LocationInput
                autoFocus={i === 0}
                id={f}
                inputValue={data[f] || ''}
                setValue={(value) => change(f, value)}
              />
            ) : (
              <Input
                aria-describedby={f === 'signature' ? 'description' : undefined}
                required
                autoFocus={i === 0}
                id={f}
                aria-label={f}
                placeholder={f === 'signature' ? t(`fields.${f}.placeholder`) : undefined}
                onChange={(v) => change(f, v)}
                className='w-full'
              />
            )}
          </FormGroup>
        ))}
      </div>
    </Modal>
  );
};
